import { FC } from 'react'

import { Stack, Typography, useTheme } from '@mui/material'
import { AutoCompleteOption } from '@/components/inputs/LicenseCompetitionsAutocomplete/LicenseCompetitionsAutocomplete'

import { COMPETITIONS_LIST_HEIGHT } from './constants'
import { SelectedCompetitionsList } from './SelectedCompetitionsList'

type SelectedCompetitionsSectionProps = {
  selectedCompetitionsList: AutoCompleteOption[]
  selectedCompetitionIds: string[]
  onCompetitionToggle: (competition: AutoCompleteOption) => void
  debouncedSearchQuery: string
}

export const SelectedCompetitionsSection: FC<SelectedCompetitionsSectionProps> = ({
  selectedCompetitionsList,
  selectedCompetitionIds,
  onCompetitionToggle,
  debouncedSearchQuery
}) => {
  const theme = useTheme()
  if (!selectedCompetitionsList.length || debouncedSearchQuery) {
    return null
  }

  return (
    <Stack
      sx={{
        flex: 1,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        overflow: 'hidden',
        backgroundColor:
          theme.palette.mode === 'light'
            ? theme.palette.common.white
            : theme.palette.background.default
      }}
    >
      <Stack
        sx={{
          p: 1,
          borderBottom: '1px solid',
          borderColor: 'divider'
        }}
      >
        <Typography variant="subtitle2">
          Selected Competitions ({selectedCompetitionsList.length})
        </Typography>
      </Stack>
      <Stack sx={{ flex: '0 0 auto', height: COMPETITIONS_LIST_HEIGHT }}>
        <SelectedCompetitionsList
          selectedCompetitionsList={selectedCompetitionsList}
          selectedCompetitionIds={selectedCompetitionIds}
          onCompetitionToggle={onCompetitionToggle}
        />
      </Stack>
    </Stack>
  )
}
